exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper-news .sectionNewsPost .content img {\n    height: auto;\n}\n", ""]);

// exports
